import { BrightyMessagesResponseDTO, FindBrightyChatByIdDTO, getAllTitlesResponseDTO, UserMessage } from "./brighty/dto.ts";
import { ChatBotRequestDTO, ChatBotResponseDTO, ChatDTO, FindChatBotFilterDTO, MessageFilterDTO, MessageResponse, TopicUnseenInfoDTO } from "./dto.ts";
import { ChatServiceImpl } from "./serviceImpl.ts";


export interface ChatService {
    findChats(topic: string): Promise<ChatDTO[]>
    findChatsByLoggedUser(): Promise<ChatDTO[]>
    findMessages(chatId: number, filter: MessageFilterDTO): Promise<MessageResponse>
    setChatSeen(chatId: number): Promise<void>
    unSeenMessages(topic: string): Promise<TopicUnseenInfoDTO[]>
    findChatBot(filter: FindChatBotFilterDTO): Promise<BrightyMessagesResponseDTO>
    findChatBotById(request: { thread_id: string, user_id: string }): Promise<FindBrightyChatByIdDTO>
    questionBot(request: UserMessage): Promise<void>
    getAllBotTitles(): Promise<getAllTitlesResponseDTO>
    deleteBotChat(thread_id: string): Promise<void>
}

export function NewChatService(): ChatService {
    return new ChatServiceImpl();
}